var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249,
    height: 66,
    viewBox: "0 0 249 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M37.736 1.232v.038l-.052 48.995L25.36 22.973 37.684 1.14z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M50.005 22.973L37.684 50.265l.052-48.995v-.038z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M.156 18.707l.028.025 37.5 31.533-28.828-8.103L.052 18.688z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M24.697 23.283l12.987 26.982-37.5-31.533-.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M75.278 18.787l-.029.024-37.566 31.454L50.67 23.282l24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M66.51 42.161l-28.827 8.104L75.25 18.811l.03-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M3.876 56.19l.026-.005 33.782-5.92-17.316 11.812-16.55-5.84z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M17.372 45.088l20.312 5.177-33.782 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M71.479 56.26l-.026-.004-33.77-5.991 20.313-5.178 13.553 11.15z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M55 62.076L37.684 50.265l33.769 5.991.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M40.677 65.08h-5.988l2.995-14.815z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M37.787 1.18v.038l-.052 48.995-12.323-27.291L37.735 1.088z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M50.057 22.922L37.735 50.213l.052-48.995V1.18z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M.207 18.656l.029.024 37.5 31.533-28.829-8.102L.103 18.636z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M24.749 23.232l12.986 26.981L.236 18.68l-.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M75.33 18.735l-.029.025-37.566 31.453 12.986-26.982 24.646-4.595z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M66.562 42.11l-28.827 8.103L75.301 18.76l.029-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M3.927 56.138l.026-.005 33.782-5.92L20.42 62.026 3.87 56.184z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M17.424 45.037l20.311 5.176-33.782 5.92-.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M71.53 56.21l-.025-.005-33.77-5.992 20.312-5.177L71.6 56.185z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M55.052 62.025L37.735 50.213l33.77 5.992.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M40.728 65.029h-5.987l2.994-14.816z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M37.839 1.129v.038l-.052 48.995L25.464 22.87 37.787 1.037z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M50.108 22.87L37.787 50.162l.052-48.995v-.038z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M.259 18.604l.029.025 37.499 31.533-28.828-8.103L.155 18.585z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M24.8 23.18l12.987 26.982-37.5-31.533-.028-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M75.381 18.684l-.028.024-37.566 31.454 12.985-26.983 24.647-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M66.613 42.058l-28.826 8.104 37.566-31.454.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M3.979 56.086l.026-.005 33.782-5.92L20.47 61.975 3.92 56.133z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M17.475 44.985l20.312 5.177-33.782 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M71.582 56.158l-.026-.005-33.77-5.991L58.1 44.984l13.553 11.15z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M55.103 61.973L37.787 50.162l33.77 5.991.025.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M40.78 64.977h-5.988l2.995-14.815z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M37.89 1.077v.038l-.052 48.995-12.323-27.292L37.838.985z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M50.16 22.818L37.838 50.11l.052-48.995v-.038z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M.31 18.553l.03.024L37.837 50.11 9.011 42.007.206 18.533z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M24.852 23.129L37.838 50.11.34 18.577l-.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M75.433 18.632l-.029.025L37.838 50.11l12.986-26.982 24.646-4.595z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M66.665 42.006L37.838 50.11l37.566-31.453.029-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M4.03 56.034l.027-.004 33.781-5.92-17.316 11.812-16.549-5.84z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M17.527 44.933l20.311 5.177-33.781 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M71.634 56.106l-.026-.004-33.77-5.992 20.312-5.177 13.553 11.149z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M55.155 61.922L37.838 50.11l33.77 5.992.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M40.831 64.926h-5.987l2.994-14.816z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M37.942 1.026v.037L37.89 50.06 25.567 22.767 37.89.933z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M50.211 22.767L37.89 50.059l.052-48.996v-.037z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M.362 18.501l.029.024L37.89 50.06 9.062 41.956.258 18.482z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M24.903 23.077L37.89 50.06.39 18.525l-.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M75.484 18.58l-.028.025L37.89 50.06l12.986-26.983 24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M66.717 41.955L37.89 50.059l37.566-31.454.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M4.082 55.983l.026-.005 33.782-5.92-17.316 11.813L4.025 56.03z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M17.578 44.882l20.312 5.176-33.782 5.92-.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M71.685 56.055l-.026-.005-33.769-5.991 20.312-5.178L71.755 56.03z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M55.206 61.87L37.89 50.06l33.77 5.991.025.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M40.883 64.874h-5.987L37.89 50.06z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M37.993.974v.038l-.052 48.995-12.323-27.292L37.941.882z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M50.263 22.715L37.94 50.007l.052-48.995V.974z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M.413 18.45l.03.024L37.94 50.007 9.114 41.904.309 18.43z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M24.955 23.025L37.94 50.007.442 18.474l-.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M75.536 18.53l-.029.023-37.566 31.454 12.986-26.983 24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M66.768 41.903l-28.827 8.104 37.566-31.453.029-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M4.134 55.931l.026-.004 33.782-5.92-17.317 11.812-16.548-5.84z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M17.63 44.83l20.312 5.177-33.782 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M71.737 56.003l-.026-.005-33.77-5.99 20.312-5.179 13.554 11.15z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M55.258 61.819L37.942 50.007l33.769 5.991.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M40.934 64.823h-5.987l2.994-14.816z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M38.045.923V.96l-.052 48.996L25.67 22.664 37.993.83z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M50.314 22.664L37.993 49.956 38.045.96V.923z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M.465 18.398l.029.024 37.499 31.534-28.828-8.103L.361 18.379z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M25.006 22.974l12.987 26.982-37.5-31.534-.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M75.588 18.478l-.03.024-37.565 31.454 12.986-26.983 24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M66.82 41.852l-28.827 8.104 37.566-31.454.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M4.185 55.88l.026-.005 33.782-5.92-17.316 11.813-16.549-5.841z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M17.682 44.779l20.311 5.176-33.782 5.92-.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M71.788 55.951l-.026-.004-33.769-5.991 20.312-5.178 13.553 11.149z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M55.31 61.767L37.992 49.956l33.77 5.99.025.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M40.986 64.771h-5.987l2.994-14.815z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M38.096.871v.038l-.051 48.995-12.323-27.292L38.045.78z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M50.366 22.612L38.045 49.904 38.097.909V.87z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M.517 18.346l.028.025 37.5 31.533L9.217 41.8.413 18.327z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M25.058 22.922l12.987 26.982L.544 18.37l-.028-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M75.64 18.426l-.03.024-37.566 31.454L51.03 22.921l24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M66.871 41.8l-28.827 8.104L75.61 18.45l.03-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M4.237 55.828l.026-.004 33.782-5.92-17.316 11.812-16.55-5.84z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M17.733 44.727l20.312 5.177-33.782 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M71.84 55.9l-.026-.005-33.77-5.991 20.313-5.178 13.553 11.15z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M55.361 61.715L38.045 49.904l33.769 5.991.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M41.038 64.72H35.05l2.995-14.816z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M38.148.82v.037l-.052 48.995-12.323-27.291L38.096.727z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M50.418 22.56L38.096 49.853 38.148.857V.82z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M.568 18.295l.029.024 37.5 31.533L9.267 41.75.464 18.275z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M25.11 22.87l12.986 26.982L.597 18.32l-.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M75.69 18.374l-.028.025-37.566 31.453L51.082 22.87l24.646-4.595z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M66.923 41.748l-28.827 8.104L75.662 18.4l.029-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M4.288 55.777l.026-.005 33.782-5.92L20.78 61.665 4.231 55.824z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M17.785 44.676l20.311 5.176-33.782 5.92-.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M71.892 55.848l-.026-.004-33.77-5.992 20.312-5.177 13.553 11.149z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M55.413 61.664L38.096 49.852l33.77 5.992.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "M41.09 64.668h-5.988l2.994-14.816z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M38.2.768v.038L38.148 49.8 25.825 22.509 38.148.676z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M50.47 22.509L38.147 49.801 38.2.806V.768z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M.62 18.243l.029.025L38.148 49.8 9.32 41.698.516 18.224z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M25.161 22.82L38.148 49.8.648 18.269l-.028-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M75.742 18.323l-.028.024-37.566 31.454 12.985-26.983 24.647-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M66.974 41.697L38.148 49.8l37.566-31.454.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M4.34 55.725l.026-.005 33.782-5.92-17.316 11.813-16.55-5.841z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M17.836 44.624l20.312 5.177-33.782 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M71.943 55.797l-.026-.005-33.77-5.991 20.313-5.178 13.553 11.15z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M55.464 61.612L38.148 49.801l33.77 5.991.025.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M41.14 64.616h-5.987l2.995-14.815z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M38.251.716v.038L38.2 49.749 25.876 22.457 38.2.624z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M50.52 22.457L38.2 49.75 38.25.754V.716z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M.671 18.192l.03.024 37.498 31.533-28.827-8.103L.567 18.172z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M25.213 22.768l12.986 26.981L.7 18.216l-.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M75.794 18.271l-.029.025L38.2 49.749l12.986-26.982 24.646-4.595z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M67.026 41.645L38.199 49.75l37.566-31.453.029-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M4.392 55.673l.026-.004 33.781-5.92-17.316 11.812-16.549-5.84z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M17.888 44.572l20.311 5.177-33.781 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M71.995 55.745l-.026-.004-33.77-5.992 20.312-5.177L72.064 55.72z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M55.516 61.56L38.199 49.75l33.77 5.99.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    d: "M41.192 64.565h-5.987l2.994-14.816z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M38.303.665v.037l-.052 48.996-12.323-27.292L38.25.572z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M50.572 22.406L38.251 49.698 38.303.702V.665z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M.723 18.14l.029.024L38.25 49.698 9.423 41.595.62 18.12z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M25.264 22.716l12.987 26.982L.75 18.164l-.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M75.845 18.22l-.028.024L38.25 49.698l12.986-26.983 24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M67.078 41.594L38.25 49.698l37.566-31.454.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M4.443 55.622l.026-.005 33.782-5.92L20.935 61.51 4.386 55.669z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M17.94 44.52l20.311 5.177-33.782 5.92-.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M72.046 55.694l-.026-.005-33.769-5.991 20.312-5.178 13.553 11.149z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M55.567 61.51L38.251 49.697l33.77 5.991.025.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M41.244 64.513h-5.987l2.994-14.815z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M38.354.613v.038l-.052 48.995L25.98 22.354 38.302.521z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M50.624 22.354L38.302 49.646 38.354.651V.613z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M.774 18.089l.03.024 37.498 31.533-28.827-8.103L.67 18.07z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M25.316 22.665l12.986 26.981L.803 18.113l-.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M75.897 18.168l-.029.025-37.566 31.453 12.986-26.983 24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M67.13 41.542l-28.828 8.104 37.566-31.454.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M4.495 55.57l.026-.004 33.782-5.92-17.316 11.812-16.55-5.84z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M17.99 44.47l20.313 5.176-33.782 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M72.098 55.642l-.026-.005-33.77-5.99 20.312-5.179 13.554 11.15z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M55.619 61.458L38.303 49.646l33.769 5.991.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M41.295 64.462h-5.987l2.994-14.816z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M38.406.562v.037l-.052 48.995-12.323-27.291L38.354.469z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M50.675 22.303L38.354 49.594 38.406.6V.562z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M.826 18.037l.029.024 37.499 31.534-28.828-8.103L.722 18.018z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M25.367 22.613l12.987 26.982L.854 18.06l-.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M75.949 18.117l-.03.024-37.565 31.454L51.34 22.612l24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M67.18 41.49l-28.826 8.105L75.92 18.14l.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M4.546 55.519l.026-.005 33.782-5.92-17.316 11.813L4.49 55.566z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M18.043 44.418l20.311 5.176-33.782 5.92-.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M72.15 55.59l-.027-.004-33.769-5.991 20.312-5.178 13.553 11.149z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M55.67 61.406L38.354 49.595l33.77 5.99.025.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M41.347 64.41H35.36l2.994-14.815z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M38.458.51v.038l-.052 48.995-12.323-27.292L38.406.418z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M50.727 22.251L38.406 49.543 38.458.548V.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M.878 17.985l.028.025 37.5 31.533L9.578 41.44.774 17.966z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M25.419 22.561l12.987 26.982L.906 18.01l-.028-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M76 18.065l-.029.024-37.566 31.454L51.391 22.56l24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M67.232 41.439l-28.827 8.104 37.566-31.454.03-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M4.598 55.467l.026-.004 33.782-5.92L21.09 61.355l-16.55-5.84z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M18.094 44.366l20.312 5.177-33.782 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M72.201 55.539l-.026-.005-33.77-5.991 20.313-5.178 13.553 11.15z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M55.722 61.354L38.406 49.543l33.769 5.991.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M41.399 64.358H35.41l2.995-14.815z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M38.51.458v.038l-.053 48.995L26.134 22.2 38.457.366z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M50.779 22.2L38.457 49.49 38.51.496V.458z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M.93 17.934l.028.024 37.5 31.533L9.628 41.39.825 17.914z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M25.47 22.51L38.458 49.49.958 17.958l-.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M76.052 18.013l-.029.025L38.457 49.49 51.443 22.51l24.646-4.595z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M67.284 41.387l-28.827 8.104 37.566-31.453.029-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M4.65 55.416l.025-.005 33.782-5.92-17.316 11.813-16.549-5.842z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M18.146 44.315l20.311 5.176-33.782 5.92-.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M72.253 55.487l-.026-.004-33.77-5.992 20.312-5.177 13.553 11.149z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M55.774 61.303L38.457 49.49l33.77 5.992.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M41.45 64.307h-5.987l2.994-14.816z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M38.56.407v.038L38.51 49.44 26.186 22.148 38.509.315z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M50.83 22.148L38.51 49.44 38.56.445V.407z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M.98 17.882l.03.025L38.509 49.44 9.68 41.337.877 17.863z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M25.522 22.458L38.51 49.44l-37.5-31.533-.028-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M76.103 17.962l-.028.024L38.509 49.44l12.985-26.983 24.647-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M67.335 41.336L38.51 49.44l37.566-31.454.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M4.701 55.364l.026-.005 33.782-5.92-17.316 11.813-16.55-5.841z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M18.197 44.263L38.51 49.44 4.727 55.36l-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M72.304 55.436l-.026-.005-33.77-5.991 20.313-5.178 13.553 11.15z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M55.825 61.251L38.51 49.44l33.77 5.991.025.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M41.502 64.255h-5.988L38.51 49.44z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M38.612.355v.038l-.052 48.995-12.323-27.292L38.56.263z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M50.882 22.096L38.56 49.388 38.612.393V.355z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M1.032 17.83l.03.025L38.56 49.388 9.733 41.285.928 17.811z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M25.574 22.407L38.56 49.388 1.061 17.855l-.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M76.155 17.91l-.029.025L38.56 49.388l12.986-26.982 24.646-4.595z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M67.387 41.284L38.56 49.388l37.566-31.453.029-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M4.753 55.312l.026-.004 33.782-5.92L21.244 61.2 4.695 55.36z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M18.249 44.211l20.311 5.177-33.781 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M72.356 55.384l-.026-.004-33.77-5.992 20.312-5.177L72.425 55.36z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M55.877 61.2L38.56 49.388l33.77 5.992.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M41.553 64.204h-5.987l2.994-14.816z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M38.664.304V.34l-.052 48.996-12.323-27.292L38.612.21z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M50.933 22.045L38.612 49.337 38.664.34V.304z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M1.084 17.78l.029.023 37.499 31.534-28.828-8.103L.98 17.76z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M25.625 22.355l12.987 26.982-37.5-31.534-.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M76.206 17.859l-.028.024-37.566 31.454 12.985-26.983 24.647-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M67.439 41.233l-28.827 8.104 37.566-31.454.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M4.804 55.26l.026-.004 33.782-5.92L21.296 61.15 4.747 55.308z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M18.3 44.16l20.312 5.176-33.782 5.92-.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M72.407 55.333l-.026-.005-33.769-5.991 20.312-5.178 13.553 11.149z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M55.928 61.148L38.612 49.337l33.77 5.991.025.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M41.605 64.152h-5.987l2.994-14.815z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M38.715.252V.29l-.052 48.995L26.34 21.993 38.663.16z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M50.985 21.993L38.663 49.285 38.715.29V.252z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M1.135 17.728l.03.024 37.498 31.533-28.827-8.103L1.03 17.708z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M25.677 22.303l12.986 26.982L1.164 17.752l-.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M76.258 17.807l-.029.024-37.566 31.454L51.65 22.302l24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M67.49 41.181l-28.827 8.104L76.23 17.832l.03-.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M4.856 55.21l.026-.005 33.782-5.92-17.316 11.812-16.55-5.84z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M18.352 44.108l20.312 5.177-33.782 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M72.459 55.281l-.026-.005-33.77-5.99 20.312-5.179 13.554 11.15z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M55.98 61.097L38.664 49.285l33.769 5.991.026.005z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M41.656 64.1H35.67l2.994-14.815z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M38.767.2v.038l-.052 48.996-12.323-27.292L38.715.108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M51.036 21.942L38.715 49.234 38.767.238V.201z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M1.187 17.676l.029.024 37.499 31.534L9.887 41.13 1.083 17.657z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M25.728 22.252l12.987 26.982L1.215 17.7l-.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M76.31 17.756l-.03.024-37.565 31.454L51.7 22.25l24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M67.542 41.13l-28.827 8.104L76.28 17.78l.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M4.907 55.158l.026-.005 33.782-5.92L21.4 61.046 4.85 55.205z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M18.404 44.057l20.311 5.176-33.782 5.92-.026.005z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M72.51 55.23l-.026-.005-33.769-5.991 20.312-5.178L72.58 55.205z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M56.031 61.045L38.715 49.234l33.77 5.99.025.005z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M41.708 64.049h-5.987l2.994-14.815z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.875.092V.13l-.052 48.995L26.5 21.833 38.823 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.145 21.833L38.823 49.125 38.875.13V.092z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.295 17.568l.03.024 37.498 31.533-28.827-8.103L1.19 17.548z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.837 22.144l12.986 26.981L1.324 17.592l-.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.418 17.647l-.029.025-37.566 31.453L51.81 22.143l24.646-4.595z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.65 41.021l-28.827 8.104L76.39 17.672l.029-.025z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.016 55.05l.026-.005 33.781-5.92-17.316 11.812-16.549-5.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.512 43.948l20.311 5.177-33.781 5.92-.026.004z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72.619 55.121l-.026-.004-33.77-5.992 20.312-5.177L72.69 55.097z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.14 60.937L38.823 49.125l33.77 5.992.026.004z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.816 63.94H35.83l2.994-14.815z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M38.767.2v.038l-.052 48.996-12.323-27.292L38.715.108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#db272c",
    d: "M51.036 21.942L38.715 49.234 38.767.238V.201z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M1.187 17.676l.029.024 37.499 31.534L9.887 41.13 1.083 17.657z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#db272c",
    d: "M25.728 22.252l12.987 26.982L1.215 17.7l-.028-.024z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M76.31 17.756l-.03.024-37.565 31.454L51.7 22.25l24.646-4.594z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#db272c",
    d: "M67.542 41.13l-28.827 8.104L76.28 17.78l.029-.024z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M4.907 55.158l.026-.005 33.782-5.92L21.4 61.046 4.85 55.205z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#db272c",
    d: "M18.404 44.057l20.311 5.176-33.782 5.92-.026.005z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M72.51 55.23l-.026-.005-33.769-5.991 20.312-5.178L72.58 55.205z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#db272c",
    d: "M56.031 61.045L38.715 49.234l33.77 5.99.025.005z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M41.708 64.049h-5.987l2.994-14.815z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M96.862 52.19h-2.736l-.377-2.445c-.362-.361-.818-.647-1.368-.857-.55-.21-1.2-.316-1.948-.316-1.597 0-2.826.58-3.687 1.74-.86 1.16-1.291 2.672-1.291 4.538v.643c0 1.865.428 3.382 1.286 4.55.856 1.168 2.067 1.752 3.63 1.752.722 0 1.384-.105 1.984-.315.602-.21 1.066-.496 1.394-.857l.377-2.445h2.736v3.63c-.74.857-1.683 1.54-2.83 2.048s-2.43.762-3.851.762c-2.462 0-4.478-.853-6.05-2.558-1.571-1.706-2.357-3.895-2.357-6.567v-.618c0-2.664.781-4.853 2.344-6.567 1.563-1.714 3.584-2.571 6.063-2.571 1.42 0 2.702.258 3.845.775 1.143.517 2.088 1.2 2.836 2.048z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M107.084 50.224h.076l2.067 6.466h-4.21zm-8.722 14.13h6.252v-2.206l-1.273-.227.806-2.52h5.95l.807 2.52-1.274.227v2.206h6.252v-2.206l-1.31-.19-5.547-15.957h-3.768L99.672 61.96l-1.31.189z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M135.848 46.001v2.22l-1.966.377v15.756h-3.668L122.803 52l-.076.013v9.756l1.966.378v2.206h-7.6v-2.206l1.953-.378V48.598l-1.954-.378v-2.219h5.635l7.412 12.353.075-.013v-9.743l-1.966-.378v-2.219h5.634z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M143.953 50.224h.076l2.067 6.466h-4.21zm-8.722 14.13h6.252v-2.206l-1.273-.227.806-2.52h5.95l.807 2.52-1.274.227v2.206h6.253v-2.206l-1.312-.19-5.546-15.957h-3.768L136.54 61.96l-1.31.189z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M162.029 48.837c1.319 0 2.352.445 3.1 1.336.748.89 1.122 2.046 1.122 3.466v3.064c0 1.436-.374 2.6-1.121 3.492-.749.89-1.782 1.335-3.101 1.335h-2.433V48.838zm-8.068-2.836v2.22l1.954.377V61.77l-1.954.378v2.206h8.257c2.243 0 4.092-.712 5.546-2.137 1.453-1.424 2.18-3.262 2.18-5.514v-3.038c0-2.244-.727-4.082-2.18-5.515-1.454-1.432-3.303-2.149-5.546-2.149z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M171.734 48.22v-2.219h7.6v2.22l-1.966.377V61.77l1.967.378v2.206h-7.6v-2.206l1.966-.378V48.598z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M192.583 56.287h-6.215v5.243h5.925l.164-2.193h2.798v5.017h-14.52v-2.206l1.953-.378V48.598l-1.954-.378v-2.219h14.496v5.03h-2.824l-.164-2.194h-5.874v4.614h6.215z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M215.977 46.001v2.22l-1.966.377v15.756h-3.668L202.932 52l-.077.013v9.756l1.967.378v2.206h-7.6v-2.206l1.953-.378V48.598l-1.954-.378v-2.219h5.634l7.412 12.353.076-.013v-9.743l-1.967-.378v-2.219h5.635z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M231.103 51.863h-2.76l-.48-2.521c-.319-.202-.785-.379-1.398-.53a8.118 8.118 0 0 0-1.954-.227c-1.009 0-1.788.213-2.338.637-.551.424-.827.973-.827 1.645 0 .622.288 1.132.864 1.53.576.4 1.57.823 2.981 1.268 2.025.563 3.561 1.306 4.607 2.231 1.047.925 1.57 2.138 1.57 3.643 0 1.571-.622 2.81-1.866 3.718-1.244.908-2.883 1.361-4.916 1.361-1.454 0-2.766-.23-3.938-.693-1.173-.462-2.15-1.1-2.932-1.916v-3.831h2.85l.39 2.609c.37.302.872.552 1.506.75.635.197 1.342.296 2.124.296 1.009 0 1.775-.206 2.3-.617.525-.412.788-.963.788-1.652 0-.706-.25-1.273-.75-1.702-.5-.428-1.376-.832-2.628-1.21-2.177-.63-3.823-1.378-4.941-2.243-1.117-.866-1.676-2.05-1.676-3.555 0-1.487.63-2.704 1.89-3.649 1.26-.945 2.845-1.43 4.752-1.456 1.412 0 2.698.214 3.857.643 1.16.429 2.135 1 2.925 1.714z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bf272d",
    d: "M244.666 56.287h-6.214v5.243h5.924l.164-2.193h2.798v5.017h-14.521v-2.206l1.954-.378V48.598l-1.954-.378v-2.219h14.496v5.03h-2.824l-.163-2.194h-5.874v4.614h6.214z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13506c",
    d: "M81.59 15.29v-2.48h8.502v2.48l-2.2.423v14.733l2.2.424v2.467h-8.501V30.87l2.2-.424V15.713z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13506c",
    d: "M91.53 30.87l1.974-.424v-9.46l-2.185-.423v-2.48h6.02l.183 2.184c.508-.78 1.133-1.386 1.876-1.818.742-.433 1.574-.649 2.495-.649 1.542 0 2.745.484 3.61 1.452.864.968 1.296 2.486 1.296 4.554v6.64l1.975.424v2.467h-7.867V30.87l1.762-.424V23.82c0-1.025-.208-1.75-.62-2.178-.415-.427-1.04-.641-1.876-.641-.545 0-1.034.11-1.466.33a3.029 3.029 0 0 0-1.086.938v8.177l1.664.424v2.467H91.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13506c",
    d: "M109.606 20.563v-2.48h6.019l.17 2.015a5.126 5.126 0 0 1 1.84-1.699c.737-.399 1.59-.599 2.558-.599.978 0 1.814.216 2.51.649.695.432 1.221 1.085 1.579 1.96.47-.819 1.08-1.458 1.832-1.918.752-.46 1.636-.69 2.65-.69 1.505 0 2.691.519 3.561 1.557.87 1.039 1.305 2.62 1.305 4.744v6.344l1.987.424v2.467h-7.881V30.87l1.776-.424v-6.358c0-1.156-.188-1.96-.564-2.41-.376-.452-.935-.677-1.677-.677-.583 0-1.089.129-1.516.388a2.823 2.823 0 0 0-1.022 1.078c0 .178.004.331.014.458.009.127.014.256.014.388v7.133l1.663.424v2.467h-7.43V30.87l1.665-.424v-6.358c0-1.127-.19-1.925-.565-2.39-.376-.465-.94-.697-1.691-.697-.556 0-1.041.106-1.46.317-.418.211-.764.51-1.036.895v8.233l1.777.424v2.467h-7.867V30.87l1.988-.424v-9.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13506c",
    d: "M142.92 11.343h-4.118v3.088h4.118zm-6.105 21.994h8.078V30.87l-1.973-.424V18.082h-6.317v2.481l2.2.424v9.46l-1.988.423z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13506c",
    d: "M150.618 25.836c0-1.438.232-2.603.697-3.496.465-.893 1.201-1.34 2.207-1.34.61 0 1.134.127 1.572.381.437.254.786.611 1.05 1.072v6.626a2.647 2.647 0 0 1-1.05 1.008c-.438.23-.971.345-1.6.345-1.015 0-1.749-.383-2.2-1.148-.45-.766-.676-1.817-.676-3.152zm-4.117.296c0 2.246.524 4.059 1.572 5.436 1.048 1.376 2.506 2.065 4.377 2.065.79 0 1.49-.15 2.101-.451a4.614 4.614 0 0 0 1.594-1.311v1c0 1.09-.25 1.941-.748 2.553-.498.61-1.25.916-2.256.916a8.583 8.583 0 0 1-2.086-.247 13.088 13.088 0 0 1-1.974-.67l-.761 2.89c.733.367 1.532.656 2.396.868.865.211 1.682.317 2.453.317 2.21 0 3.945-.6 5.21-1.798 1.264-1.198 1.896-2.803 1.896-4.814V18.082h-3.581L156.398 20c-.46-.706-1.015-1.248-1.663-1.629-.65-.38-1.402-.57-2.256-.57-1.89 0-3.358.737-4.406 2.213-1.048 1.475-1.572 3.416-1.572 5.822z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13506c",
    d: "M163.053 30.87l1.974-.424v-9.46l-2.186-.423v-2.48h6.02l.184 2.226c.356-.789.817-1.404 1.381-1.846a3.085 3.085 0 0 1 1.96-.663c.215 0 .444.017.683.05.24.032.44.072.6.119l-.438 3.75-1.691-.042c-.602 0-1.1.117-1.494.353a2.276 2.276 0 0 0-.903 1v7.416l1.975.424v2.467h-8.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13506c",
    d: "M179.372 30.15c-.334-.29-.5-.695-.5-1.212 0-.574.225-1.064.676-1.473.452-.409 1.114-.614 1.988-.614h2.1v2.327c-.282.404-.676.74-1.184 1.008a3.565 3.565 0 0 1-1.692.402c-.591 0-1.055-.146-1.388-.438zm9.707 3.187V30.87l-1.255-.17a4.534 4.534 0 0 1-.049-.592 26.518 26.518 0 0 1-.007-.663v-6.302c0-1.71-.59-3.028-1.77-3.954-1.18-.926-2.714-1.389-4.603-1.389-1.147 0-2.207.174-3.18.521-.972.348-1.835.776-2.587 1.283l-.013 3.385h3.101l.268-1.636c.226-.15.522-.28.888-.388a4.436 4.436 0 0 1 1.255-.162c.827 0 1.452.202 1.875.606.423.405.634.973.634 1.706v1.495h-2.1c-2.218 0-3.901.39-5.048 1.17-1.146.78-1.72 1.885-1.72 3.313 0 1.4.44 2.508 1.318 3.32.88.813 2.066 1.22 3.56 1.22.903 0 1.704-.174 2.404-.521a5.68 5.68 0 0 0 1.784-1.369c.047.274.113.543.197.812.085.267.184.528.296.782z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13506c",
    d: "M197.636 30.474c.733 0 1.32-.213 1.763-.64.44-.428.661-1 .661-1.714h3.723l.042.085c.038 1.542-.54 2.831-1.735 3.87-1.193 1.039-2.677 1.558-4.454 1.558-2.275 0-4.028-.72-5.259-2.157-1.231-1.438-1.847-3.285-1.847-5.54v-.424c0-2.246.633-4.093 1.897-5.541 1.264-1.447 3.065-2.17 5.406-2.17 1.232 0 2.336.182 3.314.55.977.366 1.79.883 2.439 1.55l.056 4.075H200.3l-.676-2.384a2.607 2.607 0 0 0-.761-.444 2.824 2.824 0 0 0-1.03-.175c-1.166 0-1.987.422-2.467 1.268-.48.846-.72 1.937-.72 3.27v.424c0 1.363.222 2.46.664 3.292.442.831 1.217 1.247 2.326 1.247z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13506c",
    d: "M211.664 11.343h-4.116v3.088h4.116zm-6.104 21.994h8.078V30.87l-1.974-.424V18.082h-6.316v2.481l2.2.424v9.46l-1.988.423z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13506c",
    d: "M219.715 15.883h3.299l3.891-3.666-.028-.084h-4.356zm-.607 9.686c0-1.354.245-2.458.733-3.314.489-.855 1.27-1.282 2.341-1.282 1.072 0 1.856.427 2.355 1.282.498.856.747 1.96.747 3.314v.295c0 1.382-.247 2.496-.74 3.342-.494.846-1.272 1.268-2.334 1.268-1.09 0-1.88-.42-2.369-1.261-.488-.841-.733-1.958-.733-3.349zm-4.117.295c0 2.294.638 4.163 1.911 5.605 1.273 1.443 3.043 2.164 5.308 2.164 2.237 0 3.992-.721 5.267-2.164 1.272-1.442 1.91-3.311 1.91-5.605v-.295c0-2.284-.638-4.15-1.91-5.598-1.275-1.447-3.039-2.17-5.295-2.17-2.247 0-4.006.725-5.28 2.177-1.273 1.452-1.91 3.316-1.91 5.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13506c",
    d: "M230.951 30.87l1.974-.424v-9.46l-2.185-.423v-2.48h6.02l.184 2.184c.507-.78 1.132-1.386 1.875-1.818.742-.433 1.574-.649 2.495-.649 1.541 0 2.744.484 3.61 1.452.864.968 1.296 2.486 1.296 4.554v6.64l1.974.424v2.467h-7.867V30.87l1.763-.424V23.82c0-1.025-.207-1.75-.62-2.178-.415-.427-1.04-.641-1.876-.641a3.18 3.18 0 0 0-1.467.33 3.028 3.028 0 0 0-1.086.938v8.177l1.665.424v2.467h-7.755z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo18);
export default __webpack_public_path__ + "static/media/Logo18.c30429cb138a491cad16cf708a7bc588.svg";
export { ForwardRef as ReactComponent };